import i18next from "src/i18n/config";

import { FormValues } from "../../ProvisioningPage";
import { Connection, ConnectionName } from "../../types";

const isConnectionEnabled = (internetConfig: Connection[], name: ConnectionName) => {
    const wifiConnection = internetConfig.find((item) => item.type === name);
    if (name === "wifi") {
        return Boolean(wifiConnection?.networks?.length);
    }
    return Boolean(wifiConnection);
};
export const getConnections = (internetConfig: Connection[]) => {
    const connections: ConnectionName[] = [];
    const wifiEnabled = isConnectionEnabled(internetConfig, "wifi");
    const ethernetEnabled = isConnectionEnabled(internetConfig, "ethernet");
    const modemEnabled = isConnectionEnabled(internetConfig, "modem");

    if (wifiEnabled) {
        connections.push("wifi");
    }
    if (ethernetEnabled) {
        connections.push("ethernet");
    }
    if (modemEnabled) {
        connections.push("modem");
    }

    return connections;
};
export const hasInternetConfig = (internetConfig: Connection[] = []) => {
    const connections = getConnections(internetConfig);
    return Boolean(connections.length);
};
export const getLastEnabledConnection = (internetConfig: Connection[]) => {
    const connections = getConnections(internetConfig);
    return connections.length === 1 ? connections[0] : null;
};
export const getRequiredSections: (values: Partial<FormValues>) => [boolean, string[]] = (values: Partial<FormValues>) => {
    const requiredSections: string[] = [];

    if (values.registrationGroupId) {
        requiredSections.push(i18next.t("pages:provisioningPage.requiredSections.deviceRegistration"));
    }
    if (values.settings?.universalLicenses.length) {
        requiredSections.push(i18next.t("pages:provisioningPage.requiredSections.deviceRegistration"));
    }
    if (values.settings?.enableMdmClient) {
        requiredSections.push(i18next.t("pages:provisioningPage.requiredSections.enableMdmClient"));
    }
    if (values.settings?.enableWifi) {
        requiredSections.push(i18next.t("pages:provisioningPage.requiredSections.enableWifi"));
    }
    if (values.settings?.bootAnimationUrl) {
        requiredSections.push(i18next.t("pages:provisioningPage.requiredSections.bootAnimationUrl"));
    }
    if (values.settings?.wallpaperUrl) {
        requiredSections.push(i18next.t("pages:provisioningPage.requiredSections.wallpaperUrl"));
    }
    if (values.settings?.hostedApks.length) {
        requiredSections.push(i18next.t("pages:provisioningPage.requiredSections.preinstalledApplications"));
    }
    if (values.settings?.fDroidRepos.length) {
        requiredSections.push(i18next.t("pages:provisioningPage.requiredSections.privateRepositories"));
    }

    return [Boolean(requiredSections.length), requiredSections];
};
export const getCheckedFields = (internetConfig: Connection[]) => {
    const result: ConnectionName[] = [];

    internetConfig.forEach((item) => {
        result.push(item.type);
    });

    return result;
};
